import React from 'react';
// Constants
import {
  CompanyEmailAddress,
  CompanyName,
  LOYALFANS_URL,
  THRONE_URL,
  TWITTER_URL,
} from '../../utils/Constants';
// Components
import CallToActionOne from '../cta/CallToActionOne';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Data
import { smallPayPins } from '../../utils/data/LinksData';

// In-Person Sessions with your IRL pricing and notes
const inPersonSessions = [
  { label: 'Hourly Rate', price: '$250 per hour' },
  { label: '50% Deposit', price: 'Due at time of booking' },
  { label: 'Remainder', price: 'Due on day of session' },
  { label: 'Short Notice Fee', price: '$50' },
  { label: 'Additional 30 mins', price: '$50' },
  { label: 'Cock Play', price: 'Additional $50' },
  { label: 'Pegging', price: 'Additional $100' },
  { label: 'Cash Meets', price: '$300 minimum, public place only' },
];

// Online sessions pricing
const onlineSessions = [
  { label: 'Tribute Required', price: '$40' },
  { label: 'Voice Calls', price: '$5 / minute' },
  { label: 'Texting / Sexting', price: '$3 / minute' },
  { label: 'Video Calls', price: '$8 / minute' },
];

// Custom content pricing with notes about exclusivity
const customs = [
  { label: 'Pictures', price: '$25 each' },
  { label: 'Videos', price: '$40 each' },
  { label: 'Clips', price: '$50 each' },
];

// Notes for in-person sessions
const inPersonNotes = [
  'You are responsible for covering the hosting place, or it may be negotiable for me to host.',
  'Want to film our IRL session? I offer that as well.',
  'Cash meets must be $300 or more and in a public place.',
];

// Notes for online sessions
const onlineNotes = [
  'I offer a wide variety of online femdom/findom and BDSM services including sexting/texting, video calls, video replies, custom content, voice replies, and more.',
];

// Notes for customs
const customsNotes = [
  'Extra fee for exclusivity - won’t be posted, you’d be the only one to have it.',
];

function SessionsPageMainContainer() {
  return (
    <main role='main' className='pt-24'>
      {/* In-Person Sessions Section */}
      <section className='grid gap-y-6 mb-12'>
        <section className='grid uppercase gap-y-10 pt-4 lg:gap-y-16 px-8 sm:px-8 md:px-10 lg:px-24 lg:container lg:mx-auto lg:mt-12'>
          <MenuSection title='In-Person Sessions' items={inPersonSessions} />
          <div className='mt-4 space-y-1 text-sm text-center max-w-xl mx-auto'>
            {inPersonNotes.map((note, i) => (
              <p key={i} className='italic opacity-75'>
                {note}
              </p>
            ))}
          </div>
          <div className='mt-6 text-center'>
            <p>
              If interested, please{' '}
              <a href={`mailto:${CompanyEmailAddress}`} className='underline'>
                email
              </a>{' '}
              or{' '}
              <a
                href={LOYALFANS_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='underline'
              >
                message Me on LoyalFans
              </a>
              .
            </p>
            <p className='mt-1'>{CompanyEmailAddress}</p>
          </div>
        </section>

        {/* Online Sessions */}
        <section className='grid uppercase gap-y-10 lg:gap-y-16 px-6 sm:px-8 md:px-10 lg:px-24 lg:container lg:mx-auto lg:mt-12'>
          <MenuSection title='Online Sessions' items={onlineSessions} />
          <div className='mt-4 space-y-1 text-sm text-center max-w-xl mx-auto'>
            {onlineNotes.map((note, i) => (
              <p key={i} className='italic opacity-75'>
                {note}
              </p>
            ))}
          </div>
        </section>

        {/* Customs Section */}
        <section className='grid uppercase gap-y-10 lg:gap-y-16 px-6 sm:px-8 md:px-10 lg:px-24 lg:container lg:mx-auto lg:mt-12'>
          <MenuSection title='Custom Content' items={customs} />
          <div className='mt-2 text-center text-sm opacity-75'>
            {customsNotes.map((note, i) => (
              <p key={i} className='italic'>
                {note}
              </p>
            ))}
          </div>
        </section>
        <div className='pt-4 grid mx-auto text-center'>
          <p className='italic pb-2'>Custom Content Turnaround Times:</p>
          <p>Pictures: 1–2 days</p>
          <p>Videos (1–2 mins): 1–2 days</p>
          <p>Clips (5 mins+): 2–5 days</p>
        </div>
      </section>

      {/* Gift and Social Section */}
      <section className='grid gap-y-10 mb-8 lg:gap-y-16 px-6 sm:px-8 md:px-10 lg:px-24 lg:container lg:mx-auto mt-8'>
        <div className='grid h-fit text-center gap-y-6'>
          <div>
            <p>Want to make an impression?</p>
            <p className='text-sm pt-2 max-w-md mx-auto text-muted-foreground'>
              Treat Goddess to something special from My curated wishlist. Visit
              My{' '}
              <a
                href={THRONE_URL}
                target='_blank'
                rel='noreferrer'
                className='underline'
              >
                Throne
              </a>{' '}
              and send a gift I'll never forget.
            </p>
          </div>
          <div>
            <a
              href={THRONE_URL}
              target='_blank'
              rel='noreferrer'
              className='cursor-pointer hover:bg-colour7 border-4 shadow-cardShadow border-solid border-colour7 bg-black w-full text-center h-fit px-10 md:px-2 lg:px-12 py-2 mx-auto'
            >
              My Throne
            </a>
          </div>
        </div>
        <div className='grid grid-flow-col items-center gap-8 lg:gap-8 w-fit mx-auto'>
          {smallPayPins.map((pin) => (
            <a
              key={pin.serviceName}
              href={pin.url}
              aria-label={`${CompanyName} social media link for ${pin.serviceName}`}
              target='_blank'
              rel='noreferrer'
            >
              <div className='grid items-center justify-center text-4xl lg:text-3xl'>
                {pin.icon}
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* CTA */}
      <CallToActionOne />

      {/* Social cta */}
      <SocialMediaCtaComponent />
    </main>
  );
}

function MenuSection({ title, items }) {
  return (
    <article className='grid uppercase'>
      <section className='grid grid-cols-reg w-full gap-x-6'>
        {/* Title with responsive line breaks */}
        {[
          'In-Person Sessions',
          'Online Sessions',
          'Extended Sessions',
          'Custom Content',
        ].includes(title) ? (
          <>
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl text-colour7 font-titleFont tracking-widest'>
                {title}
              </h3>
            </div>
            <div className='grid md:hidden items-center text-colour7 font-titleFont text-2xl tracking-wider'>
              {/* Break at space for small screens */}
              {title.split(' ').map((word, idx) => (
                <React.Fragment key={idx}>
                  {word}
                  {idx === 0 && <br />}
                </React.Fragment>
              ))}
            </div>
          </>
        ) : (
          <div>
            <h3 className='text-3xl text-colour7 font-titleFont tracking-widest'>
              {title}
            </h3>
          </div>
        )}

        <div className='grid items-center'>
          <div
            className='h-[2px] -mt-4 bg-colour7'
            role='separator'
            aria-hidden='true'
          ></div>
        </div>
      </section>
      <ul className='mt-4 space-y-2'>
        {items.map((item, index) => (
          <li key={index}>
            <div className='grid grid-flow-col gap-2 text-end justify-between'>
              <div className='text-left'>{item.label}</div>
              {/* For Online Sessions, you said prices are visible, so show price */}
              <div>
                <span>{item.price}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
      {title === 'Online Sessions' && (
        <div className='text-center mt-2'>
          <p>
            Online Session Prices are Subject to Change due to availability.
          </p>
          <p>Contact Me for price information.</p>
        </div>
      )}
    </article>
  );
}

export default SessionsPageMainContainer;
